'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = require('react-bootstrap');

var _utils = require('utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationRequestModal = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(NotificationRequestModal, _Component);

  function NotificationRequestModal() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, NotificationRequestModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = NotificationRequestModal.__proto__ || (0, _getPrototypeOf2.default)(NotificationRequestModal)).call.apply(_ref, [this].concat(args))), _this), _this._input = null, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(NotificationRequestModal, [{
    key: 'handleSendDecline',
    value: function handleSendDecline() {
      var _props = this.props,
          selectedNotification = _props.selectedNotification,
          sendDecline = _props.sendDecline;

      sendDecline(selectedNotification, this._input.value.trim());
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          selectedNotification = _props2.selectedNotification,
          show = _props2.show,
          closeModal = _props2.closeModal,
          sendDecline = _props2.sendDecline,
          polyglot = _props2.polyglot;

      return _react2.default.createElement(
        _reactBootstrap.Modal,
        { dialogClassName: 'custom-modal', show: show, onHide: closeModal, animation: true },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'modal-body' },
            _react2.default.createElement(
              'form',
              { className: 'event-form', action: '', method: 'post' },
              _react2.default.createElement('button', { type: 'button', onClick: closeModal, className: 'close-modal-button icon-cg-close' }),
              _react2.default.createElement(
                'h2',
                null,
                polyglot.t('notification.request_modal.title', { title: (0, _utils.trunc)(selectedNotification.entry.item.title, 30) })
              ),
              _react2.default.createElement('input', {
                ref: function ref(comp) {
                  return _this2._input = comp;
                },
                type: 'text',
                className: 'form-control input-h1',
                placeholder: polyglot.t('notification.request_modal.input_placeholder')
              })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'modal-footer' },
            _react2.default.createElement(
              'div',
              { className: 'pull-right' },
              _react2.default.createElement(
                'button',
                {
                  type: 'button',
                  className: 'btn btn-outline',
                  onClick: sendDecline.bind(null, selectedNotification, null)
                },
                polyglot.t('notification.request_modal.submit_empty')
              ),
              _react2.default.createElement(
                'button',
                {
                  type: 'button',
                  className: 'btn btn-primary',
                  onClick: this.handleSendDecline.bind(this)
                },
                _react2.default.createElement('i', { className: 'glyphicon glyphicon-save' }),
                '\xA0',
                polyglot.t('notification.request_modal.submit')
              )
            )
          )
        )
      );
    }
  }]);
  return NotificationRequestModal;
}(_react.Component), _class.propTypes = {
  show: _propTypes2.default.bool,
  closeModal: _propTypes2.default.func,
  polyglot: _propTypes2.default.object,
  selectedNotification: _propTypes2.default.object,
  sendDecline: _propTypes2.default.func
}, _temp2);
exports.default = NotificationRequestModal;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Notification/NotificationRequestModal.js
// module id = 2238
// module chunks = 0